import { addImportMapHash } from '@ms-cloudpack/import-map';
import { z } from 'zod/v4-mini';
import { mutationProcedure } from '../trpc/common.js';
import type { ApiParams } from '../types/ApiParams.js';
import { notifyReload } from '../utilities/notifyReload.js';
import { ZodNotifyLinkChangeInput, type NotifyLinkChangeInput } from '../types/NotifyLinkChangeInput.js';

// TODO: consider whether this should be hardcoded or not
const targetEnvironment = 'browser';

/**
 * Notifies clients that a reload is needed by incrementing the session version.
 */
export async function notifyLinkChange(
  params: ApiParams<
    NotifyLinkChangeInput,
    'bus' | 'telemetryClient' | 'packageHashes' | 'packages',
    'sequence' | 'config' | 'importMap' | 'packageImportPaths' | 'resolveMap' | 'urls' | 'incrementTargetVersion'
  >,
): Promise<void> {
  const { input, ctx } = params;
  const { packagePath, definition } = input;
  const hash = input.hash || 'pending';

  ctx.packageHashes.set({ packagePath, isSourceHashingEnabled: true, targetEnvironment }, hash);

  if (definition) {
    ctx.packages.set(packagePath, definition);
    ctx.session.incrementTargetVersion(packagePath);
  } else {
    const { name, version } = await ctx.packages.get(packagePath);
    // Add linked to package version as it will always be an internal linked package.
    addImportMapHash({ packageName: name, version: `${version}-linked`, hash }, ctx);
  }

  await notifyReload({ reason: 'on-package-change-linked' }, ctx);
}

// Attach a trpc procedure to the function.
notifyLinkChange.procedure = mutationProcedure<NotifyLinkChangeInput, void>(
  notifyLinkChange,
  ZodNotifyLinkChangeInput,
  z.void(),
);
